import { useMedia } from "@next-platform/client-common-spicy-ui";
import {
  navigateRoute,
  setCreateDropdownMenu,
  setSideNavigationMenu,
  useAppDispatch,
  useAppSelector,
  useUserInfo,
  useUserSettings,
} from "@next-platform/client-common-core";
import { SyntheticEvent } from "react";

import { CREATE_DROPDOWN_LOCAL_STORAGE_KEY, SIDE_NAVIGATION_LOCAL_STORAGE_KEY } from "@/constants";
import { typedLocalStorageService } from "@/utils/localStorageRe";

export default function useNavigation() {
  const isSideNavOpen = useAppSelector((state) => state.navigation.isSideNavigationMenu);
  const isCreateDropdownOpen = useAppSelector((state) => state.navigation.isCreateDropdownOpen);
  const { isMobile } = useMedia();
  const dispatch = useAppDispatch();
  const { isProfileModified } = useUserInfo();
  const { setToShowUnsavedProfileChangesWarning } = useUserSettings();

  const handleSideNavClose = () => {
    if (!isMobile) {
      return;
    }
    dispatch(setSideNavigationMenu(false));
  };

  const checkRoute = (e: SyntheticEvent, path: string) => {
    if (isProfileModified) {
      e.preventDefault();
      dispatch(navigateRoute(path));
      setToShowUnsavedProfileChangesWarning(true);
    } else {
      dispatch(navigateRoute(""));
    }
    handleSideNavClose();
  };

  const handleSideNavToggle = (isOpen: boolean) => {
    dispatch(setSideNavigationMenu(isOpen));
    typedLocalStorageService.setItem(SIDE_NAVIGATION_LOCAL_STORAGE_KEY, String(isOpen));
  };

  const handleCreateDropdownToggle = (isOpen: boolean) => {
    dispatch(setCreateDropdownMenu(isOpen));
    typedLocalStorageService.setItem(CREATE_DROPDOWN_LOCAL_STORAGE_KEY, String(isOpen));
  };

  return { isSideNavOpen, isCreateDropdownOpen, checkRoute, handleSideNavClose, handleSideNavToggle, handleCreateDropdownToggle };
}
